if ($("#categories").length) {
    $("#categories .topic a").each(function () {
        const link = $(this).attr("href") || "";
        const fallbackImgPath = "https://cdn.myshoptet.com/prj/dist/master/cms/templates/frontend_templates/00/img/folder.svg";
        const categoryName = link
            .replace(/^\/+|\/+$/g, "")
            .split("/")
            .filter(Boolean)
            .pop();

        if (!categoryName) {
            return;
        }

        const imgPath = `/user/documents/upload/sablona/kategorie/${categoryName}.svg`;
        $(this).prepend(`<img src="${imgPath}" alt="${categoryName}" onerror="this.onerror=null;this.src='${fallbackImgPath}';">`);
    });
}


if ($("#navigation").length) {
    $("#navigation ul.menu-level-1 > li > a").each(function () {
        const link = $(this).attr("href") || "";
        const fallbackImgPath = "https://cdn.myshoptet.com/prj/dist/master/cms/templates/frontend_templates/00/img/folder.svg";
        const categoryName = link
            .replace(/^\/+|\/+$/g, "")
            .split("/")
            .filter(Boolean)
            .pop();

        if (!categoryName) {
            return;
        }

        const imgPath = `/user/documents/upload/sablona/kategorie/${categoryName}.svg`;
        $(this).prepend(`<img src="${imgPath}" alt="${categoryName}" onerror="this.onerror=null;this.src='${fallbackImgPath}';">`);
    });
}